import { Component, Inject } from "@angular/core";
import { MD_DIALOG_DATA, MdDialogRef } from "@angular/material";
import Swal from "sweetalert2";
import { LicenseService } from "../../../services/LicenseService";
import { AppLoaderService } from "../../../../services/app-loader/app-loader.service";
import { AdalService } from "../../../shared/adal.service";
import { Router } from "@angular/router";

export interface FAQDetail{
    Question,
    Answer,
    FAQId,
    ProductId,
    OrderId,
    CreatedBy,
    UpdatedBy,
}
@Component({
    selector:'import-faq',
    template:require('./import-faq.component.html'),
    styles:[require('./import-faq.component.css')]
})
export class ImportFaqComponent{
    dialogTitle='Import FAQ'
    uploadResponse='';
    FaqDisplayDetail;
    errorMessage='';
    importedFaqData=[];
    saveButtonDisabled=true;
    constructor(
        private dialogRef:MdDialogRef<ImportFaqComponent>,
        private licenseService:LicenseService,
        private appLoader:AppLoaderService,
        private adalService:AdalService,
        private router:Router,
        @Inject(MD_DIALOG_DATA) public dialogData:any,
    ){
        if (!this.adalService.getCachedToken()) {
            this.dialogRef.close(null);
            this.router.navigate(["login"]);
        }
        this.FaqDisplayDetail=dialogData.FaqDisplayDetail;
    }
    onChange(event){
        this.importedFaqData=[]
        let faqFileList:FileList=event.target.files;
        if(faqFileList.length>0){
            let faqFile:File=faqFileList[0];
            let extension=faqFile.type.toLowerCase();
            if(!(extension =="text/csv")){
                Swal.fire({
                    title:'Error',
                    text:"The faq file can be in text/csv format only."
                })
                this.saveButtonDisabled=true;
            }
            else{
                if(faqFile.size>=1048576){
                    Swal.fire({
                        title:'Error',
                        text:"The file cannot be greater than 1MB."
                    })
                    this.saveButtonDisabled=true;
                }
                else{
                    const reader=new FileReader();
                    reader.addEventListener("load",()=>{
                        if(typeof(reader.result)==='string'){
                            let csvData=reader.result;
                            this.importedFaqData=this.csvToJson(csvData.trim())
                        }    
                    });
                    reader.readAsText(faqFile);
                }
            }
        }
        else{
            Swal.fire({
                title:'Error',
                text:"FAQ file is required."
            })
            this.saveButtonDisabled=true;
        }  
    }
    deleteFAQ(index){
        this.importedFaqData.splice(index,1);
        if(this.importedFaqData.length<=0){
            this.saveButtonDisabled=true;
        }
    }
    csvToJson(csvString){
        let jsonObject=[];
        let lines=csvString.split(/\r?\n/);
        let headers=lines[0].split(',');
        if(headers[0].trim()!='Question' || headers[1].trim()!='Answer'){
            Swal.fire({
                title:'Error',
                text:'Invalid CSV file.'
            })
            this.saveButtonDisabled=true;
            return [];
        }
        this.saveButtonDisabled=false;
        for(let i=1;i<lines.length;i++){
            let data=lines[i].split(/,(?=(?:[^"]*"[^"]*")*[^"]*$)/) //splits based on only those commas that have the specified pattern after them.
            let object:FAQDetail={
                Question:"",
                Answer:"",
                OrderId:1,
                FAQId:0,
                ProductId:19,
                UpdatedBy:Number(localStorage.getItem('userid')),
                CreatedBy:Number(localStorage.getItem('userid')),
            }
            for(let j=0;j<data.length;j++){
                object[headers[j]]=data[j].replace(/["]+/g, '') //replaces one or more occurences of \" in th string with an empty character
                this.FaqDisplayDetail.forEach(element => {
                    if(element.Question==object['Question'] && element.Answer==object['Answer']){
                        object['FAQId']=element.FAQId;
                        object['OrderId']=element.OrderId;
                    }
                });
            }
            if(object['Question']!="" && object['Answer']!=""){
                jsonObject.push(object)
            }
        }
        return jsonObject;
    }
    importFaq(){
        document.getElementById('inputFaqFile').click();
    }
    onSave(){
        this.appLoader.open()
        this.licenseService.importFAQ(this.importedFaqData).subscribe((data)=>{
            if(!data.IsError && data.DataObject!=null){
               this.FaqDisplayDetail=data.DataObject;
               this.dialogRef.close(this.FaqDisplayDetail);
            }
            this.appLoader.close();
        })
    }
    onCancel(){
        this.dialogRef.close(this.FaqDisplayDetail);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/license-portal/faq/import-faq/import-faq.component.ts